import React, { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { connect } from "react-redux"
import { Tooltip } from "react-tooltip"
import { Tooltip as AntdTooltip, notification } from "antd"
import { NotificationPlacement } from "antd/es/notification/interface"
import { join } from "lodash"

import API from "../../../api"
import { ROUTES } from "../../../routes"
import { mapDispatchProps, mapStateToProps } from "../../../store/store"
// Hooks
import useInfiniteScroll from "../../../hooks/useInfiniteScroll"
// Helpers
import { isEmpty } from "../../../helpers/object"
import { debounce } from "../../../helpers/debounce"
// Components
import Checkbox, { ICON_TYPES } from "../../../components/checkbox"
import Select from "../../../components/select"
import RadioButton from "../../../components/radioButton"
import ModelCard, { TYPES } from "../../../components/modelCard"
import Paginator from "../../../components/paginator"
import Button from "../../../components/button"
import dayjs from "dayjs"
import LoadingText from "../../../components/loadingText"

const TAB_APPLIED = "APPLIED"
const TAB_APPROVED = "APPROVED"

const GuidelineMigration = (props: any) => {
  const navigate = useNavigate()

  const brandIdRef = useRef("")

  const [inputs, setInputs] = useState<any>({})
  const [brand, setBrand] = useState<any>({})

  const [campaigns, setCampaigns] = useState<any>([])
  const [campaignPaginator, setCampaignPaginator] = useState<any>(undefined)

  const [isFetching, setIsFetching] = useState(false)

  const maxRentalLimitAmbassadorOptions = [
    { name: "무제한", value: 9999 },
    ...Array.from({ length: 5 }, (_, index) => ({
      name: `${index + 1}벌`,
      value: index + 1,
    })),
  ]

  // useEffect(() => {
  //   (async () => {
  //     await fetchBrand();
  //     await fetchCampaigns(1);
  //   })()
  // }, []);

  useEffect(() => {
    /**
     * @todo 일반모델 가이드라인 동의여부 필드 확인
     */

    if (brand?.id == null) {
      setInputs({
        userTypeNormal: false,
        userTypeAmbassador: false,
        maxRentalLimitAmbassador: `${0}벌`,
        receiveAmbassadorApplyMsg: false,
      })
      return
    }

    const {
      isAmbassadorServiceEnabled,
      hasAgreedGuidelineTerms,
      rentableUserTypeFl,
      maxRentalLimitAmbassador,
      receiveAmbassadorApplyMsg,
      hasOldAmbassadorRule,
    } = brand

    setInputs({
      userTypeNormal: !hasOldAmbassadorRule,
      userTypeAmbassador: hasOldAmbassadorRule,
      maxRentalLimitAmbassador: `${maxRentalLimitAmbassador}벌`,
      receiveAmbassadorApplyMsg: receiveAmbassadorApplyMsg,
    })
  }, [brand])

  const handleInputChange = (key: string, value: any) => {
    let params: any = {}
    const copy: any = { ...inputs }
    copy[`${key}`] = value

    console.log(`${key} updated`)

    setInputs({ ...inputs, ...copy })

    switch (key) {
      case "userTypeNormal":
        params.userTypeNormal = value
        break

      case "userTypeAmbassador":
        params.userTypeAmbassador = value
        break

      case "maxRentalLimitAmbassador":
        const selected = maxRentalLimitAmbassadorOptions.filter((qty) => {
          return qty.name == value
        })[0]

        params.maxRentalLimitAmbassador = selected.value
        break

      case "receiveAmbassadorApplyMsg":
        params.receiveAmbassadorApplyMsg = value
        break
    }

    if (!isEmpty(params)) {
      // updateBrand(params);
    }
  }

  const fetchBrand = async (brandId) => {
    await API.Dev.brandShow({
      brandToken: props.auth.token,
      id: brandId,
    })
      .then((response) => {
        console.log("brand!", response.data.brand)
        setBrand(response.data.brand)
      })
      .catch((error) => {
        props.showModal({
          text: "브랜드 정보를 불러올 수 없습니다.",
        })
      })
  }

  const fetchCampaigns = async (brandId, page = 1) => {
    await API.Dev.campaignIndex({
      brandToken: props.auth.token,
      brandId: brandId,
      page: page,
    })
      .then((response) => {
        const _paginator = response.data.paginator
        // const totalCount = _paginator.total;
        setCampaigns(response.data.campaigns)
        setCampaignPaginator(_paginator)
        console.log("**** 캠페인 목록 ****")
        console.log(response.data.campaigns)
        console.log("********")
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const renderCampaignPaginator = () => {
    if (!campaignPaginator) return null

    return (
      <Paginator
        currentPage={campaignPaginator.currentPage}
        lastPage={campaignPaginator.lastPage}
        onPageChange={async (page) => {
          setIsFetching(true)
          await fetchCampaigns(brand.id, page)
          setIsFetching(false)
        }}
      />
    )
  }

  const openPopup = (path) => {
    const popupWidth = 1080
    const popupHeight = 900
    const popupX = window.screen.width / 2 - popupWidth / 2
    const popupY = window.screen.height / 2 - popupHeight / 2
    const option =
      "height=" +
      popupHeight +
      ", width=" +
      popupWidth +
      ", left=" +
      popupX +
      ", top=" +
      popupY +
      ", menubar=no, toolbar=no, resizable=yes, status=no"

    window.open(path, "popup", option)
  }

  const renderMigrationInfo = () => {
    return (
      <>
        <div className="flex flex-col pb-[40px]">
          <span className="text-[36px] font-bold">{brand.name}</span>
        </div>

        {/* 앰베서더 */}
        <div className="flex flex-col w-full gap-[50px]">
          <div className="flex flex-col gap-[15px]">
            <div className="title">
              <span className="text-[22px] font-bold">제품을 대여할 수 있는 모델</span>
            </div>

            <div className="flex flex-row gap-[18px]">
              <div className="flex flex-row items-center gap-[50px]">
                <div className="flex flex-row items-center min-w-[125px] gap-[8px]">
                  <Checkbox
                    text={"일반 모델"}
                    type={ICON_TYPES.DEFAULT}
                    checked={inputs.userTypeNormal}
                    onClick={() => {
                      // handleNormalRentableToggle();
                    }}
                  />
                </div>
                <div className="relative flex flex-row items-center min-w-[125px] gap-[8px]">
                  <Checkbox
                    text={"엠베서더 모델"}
                    type={ICON_TYPES.DEFAULT}
                    checked={inputs.userTypeAmbassador}
                    onClick={() => {
                      // handleAmbassadorRentableToggle();
                    }}
                  />
                </div>
                <div className="mx-auto"></div>
              </div>
            </div>
          </div>

          {!inputs.userTypeAmbassador ? null : (
            <div className="flex flex-col gap-[15px]">
              <div className="title">
                <span className="text-[22px] font-bold">엠베서더 모델 가이드라인</span>
              </div>
              <p>릴스 생성을 원하시는 경우, 가이드라인을 설정한 후에 제품 별 릴스로 변경하면 됩니다.</p>
              <div className="flex flex-row gap-[18px]">
                <div
                  className="flex flex-row items-center gap-[50px] cursor-pointer"
                  onClick={() => {
                    if (brand.hasOldAmbassadorRule == false) {
                      props.showModal({ text: "기존 엠베서더 룰이 없습니다." })
                      return false
                    }

                    openPopup(ROUTES.DEV_GUIDELINE_MIGRATION_AMBASSADOR_POSTING.MAKEPATH(brand.id))
                  }}
                >
                  <span className="font-bold text-[15px] text-[#000000] underline">포스팅 가이드라인 설정하기</span>
                </div>
                <div
                  className="flex flex-row items-center gap-[50px] cursor-pointer"
                  onClick={() => {
                    if (brand.hasOldAmbassadorRule == false) {
                      props.showModal({ text: "기존 엠베서더 룰이 없습니다." })
                      return false
                    }

                    openPopup(ROUTES.DEV_GUIDELINE_MIGRATION_AMBASSADOR_VIDEO.MAKEPATH(brand.id))
                  }}
                >
                  <span className="font-bold text-[15px] text-[#000000] underline">
                    릴스 가이드라인 설정하기 (선택)
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="w-full h-[2px] my-10 text-stone-600" />

        {/* 증정 */}
        <div className="w-full flex flex-col gap-[50px]">
          <div className="flex flex-col gap-[15px]">
            <div className="title">
              <span className="text-[22px] font-bold">증정</span>
            </div>

            <div className="flex flex-col gap-[15px]">
              <div key={"header"} className="py-2 flex items-center gap-1 bg-neutral-200">
                <div className="flex-grow basis-[5%]"></div>
                <div className="flex-grow basis-[5%] px-1">id</div>
                <div className="flex-grow basis-[10%] px-1">description</div>
                <div className="flex-grow basis-[10%] px-1">outputType</div>
                <div className="flex-grow basis-[5%] px-1">products count</div>
                <div className="flex-grow basis-[20%] px-1">status</div>
                <div className="flex-grow basis-[5%] px-1">totalQty</div>
                <div className="flex-grow basis-[10%] px-1">createdAt</div>
              </div>

              {!isFetching && campaigns.length <= 0 && (
                <div className="text-lg font-bold text-center py-3">캠페인이 없습니다</div>
              )}

              {campaigns.map((cpn, i) => {
                return (
                  <div
                    key={i}
                    className="py-2 flex gap-1 cursor-pointer"
                    onClick={(e) => {
                      if (cpn.outputType === 1) {
                        openPopup(ROUTES.DEV_GUIDELINE_MIGRATION_SEEDING_POSTING.MAKEPATH(brand.id, cpn.id))
                      } else if (cpn.outputType === 2) {
                        openPopup(ROUTES.DEV_GUIDELINE_MIGRATION_SEEDING_VIDEO.MAKEPATH(brand.id, cpn.id))
                      }
                    }}
                  >
                    <div className="flex-grow basis-[5%]">
                      <input
                        key={`check-${cpn.id}`}
                        type="checkbox"
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                        style={{ zoom: 1.5 }}
                      />
                    </div>
                    <div className="flex-grow basis-[5%] px-1">{cpn.id}</div>
                    <div className="flex-grow basis-[10%] px-1">{cpn.description}</div>
                    <div className="flex-grow basis-[10%] px-1">{`${cpn.outputType} (${cpn.outputTypeFl})`} </div>
                    <div className="flex-grow basis-[5%] px-1">{cpn.products?.length}</div>
                    <div className="flex-grow basis-[20%] px-1">{`${cpn.statusDesc} (${cpn.status})`}</div>
                    <div className="flex-grow basis-[5%] px-1">{cpn.totalQty}</div>
                    <div className="flex-grow basis-[10%] px-1">{dayjs(cpn.createdAt).format("YYYY-MM-DD HH:mm")}</div>
                  </div>
                )
              })}
            </div>

            <div className="mt-9 w-full text-center">- PAGE - </div>
            {renderCampaignPaginator()}
          </div>
        </div>
      </>
    )
  }

  return (
    <div
      className="relative w-full flex flex-col items-center justify-center"
      style={{ paddingTop: props.preferences.headerHeight }}
    >
      {!isFetching ? null : (
        <div className="fixed top-0 w-full h-full flex items-center justify-center bg-slate-400 opacity-50 z-[1]">
          <LoadingText
            text={"Loading"}
            render={(text) => (
              <div className="w-[180px] rounded-full p-2 text-center text-2xl font-bold text-white select-none">
                {text}
              </div>
            )}
          />
        </div>
      )}

      <div className="flex flex-col w-full mx-auto max-w-[1024px]">
        <div className="flex flex-col">
          <span className="text-[24px] font-bold">DEV/MIGRATION</span>
        </div>

        <div className="py-[40px] flex gap-3">
          <form
            onSubmit={async (e) => {
              e.preventDefault()

              var brandId = Number.parseInt(brandIdRef.current)
              if (isNaN(brandId)) {
                brandIdRef.current = ""
                alert("brandId (숫자)를 입력해주세요")
                return
              }

              setIsFetching(true)

              await Promise.all([fetchBrand(brandId), fetchCampaigns(brandId, 1)])

              setIsFetching(false)
            }}
          >
            <input
              type="text"
              className="border px-2 py-2"
              placeholder="Brand.id (숫자)"
              onChange={(e) => {
                e.preventDefault()
                brandIdRef.current = e.target.value
              }}
            />
            <button
              type="submit"
              className="ml-2 px-3 py-2 cursor-pointer select-none border text-[15px] font-bold text-white bg-slate-800"
            >
              조회
            </button>
          </form>
        </div>

        {brand?.name == null ? null : renderMigrationInfo()}
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(GuidelineMigration)
